function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Tooltip } from '@nackle/paper';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import classNames from 'classnames';
import './in-context-help.less';

var InContextHelp = function InContextHelp(props) {
  var type = props.type,
      title = props.title,
      children = props.children,
      className = props.className,
      style = props.style,
      drawerPlacement = props.drawerPlacement;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggled = _useState2[0],
      setToggle = _useState2[1];

  var toggle = function toggle() {
    setToggle(!toggled);
  };

  if (type === 'drawer') {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('in-context-help', 'in-context-help-drawer', className),
      style: style
    }, /*#__PURE__*/React.createElement(QuestionCircleTwoTone, {
      className: "question-circle-button",
      onClick: toggle
    }), /*#__PURE__*/React.createElement(Drawer, {
      style: {
        marginTop: 64
      },
      placement: drawerPlacement,
      title: title,
      visible: toggled,
      destroyOnClose: true,
      onClose: toggle
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 30
      }
    }, children)));
  } else if (type === 'tooltip') {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('in-context-help', 'in-context-help-tooltip', className),
      style: style
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: children
    }, /*#__PURE__*/React.createElement(QuestionCircleTwoTone, {
      className: "question-circle-button"
    })));
  }
};

InContextHelp.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  drawerPlacement: PropTypes.string
};
export default InContextHelp;
//# sourceMappingURL=in-context-help.js.map